<script setup lang="ts">
import { ref } from 'vue';
import Spinner from '@/components/Spinner.vue';

const props = defineProps<{
  isLoading: boolean;
  closeModal: () => void;
  onCreateFolder: (folderName: string) => void;
}>();

const isVisible = ref(true);
const folderName = ref('');

function closeModal(): void {
  if (!isVisible.value || props.isLoading) return;

  folderName.value = '';
  isVisible.value = false;
  props.closeModal();
}

function handleCreate(): void {
  if (!folderName.value || props.isLoading) return;

  props.onCreateFolder(folderName.value);
}
</script>

<template>
  <div
    v-if="isVisible"
    class="tw:p-5 tw:fixed tw:inset-0 tw:z-20 tw:flex tw:items-center tw:justify-center tw:bg-[rgba(22,30,45,0.2)]"
    @click.self="closeModal"
  >
    <div class="tw:relative">
      <div
        v-if="isLoading"
        class="tw:absolute tw:z-1 tw:inset-0 tw:flex tw:items-center tw:justify-center tw:rounded-xl tw:bg-[rgba(255,255,255,0.72)]"
      >
        <Spinner />
      </div>

      <button
        type="button"
        class="tw:absolute tw:z-2 tw:top-2 tw:right-2 tw:flex tw:h-10 tw:w-10 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full! tw:border-0 tw:bg-transparent tw:p-0 tw:text-[#7f8da1] tw:hover:bg-pr-grey100"
        aria-label="close create folder modal"
        @click="closeModal"
      >
        <span class="tw:block tw:text-5xl tw:leading-none">×</span>
      </button>

      <div
        class="tw:relative tw:w-full tw:max-w-97.5 tw:rounded-xl tw:bg-white tw:p-6 tw:shadow-[0_8px_24px_rgba(20,27,40,0.12)]"
      >
        <div class="tw:relative tw:flex tw:items-center tw:justify-between">
          <div class="tw:m-0 tw:typography-title">Create Folder</div>
        </div>

        <div class="tw:mt-2 tw:text-sm tw:leading-5 tw:text-[#48586e]">
          The vulnerability will be moved to the newly created folder.
        </div>

        <div class="tw:mt-6 tw:flex tw:flex-col tw:gap-3.5">
          <input
            v-model.trim="folderName"
            type="text"
            :disabled="isLoading"
            class="tw:h-12 tw:w-full tw:rounded-md tw:border-0 tw:bg-pr-grey100 tw:px-4 tw:text-sm tw:text-[#5d6c7f]"
            placeholder="Folder name"
          />

          <button
            type="button"
            class="tw:mt-1.5 tw:h-12 tw:w-full tw:rounded-md! tw:border-0 tw:bg-[#0063fc] tw:text-sm tw:leading-5 tw:text-white tw:transition-opacity tw:hover:opacity-90 tw:disabled:cursor-default tw:disabled:opacity-55"
            :disabled="!folderName || isLoading"
            @click="handleCreate"
          >
            Create folder
          </button>

          <button
            type="button"
            class="tw:h-12 tw:w-full tw:rounded-md tw:border-0 tw:bg-transparent tw:text-sm tw:leading-5 tw:text-[#48586e] tw:transition-opacity tw:hover:opacity-70"
            :disabled="isLoading"
            @click="closeModal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
